<template>
    <div class="table-responsive" v-loading="loading">
        <table class="table">
            <thead>
            <tr>
                <th>Campaign</th>
                <side-by-side-header :data="left" name="Current Billing Period" :colspan="colspan" @editBilling="(d) => editBilling(d.id, d.period_status)"/>
                <th class="table-center-separator" style="width: 40px;">
                </th>
                <side-by-side-header :data="right" name="Next Billing Period" :colspan="colspan" @editBilling="(d) => editBilling(d.id, d.period_status)"/>
                <th style="width: 80px;"></th>
            </tr>
            <tr>
                <th></th>
                <th v-for="c in columns">{{ c }}</th>
                <th class="table-center-separator"></th>
                <th v-for="c in columns">{{ c }}</th>
                <th></th>
            </tr>
            </thead>

            <side-by-side-row
                :row="row"
                :colspan="colspan"
                v-for="row in campaignRows"
                :key="row.campaign_id"
                @updated="updated"
            ></side-by-side-row>

            <tfoot>
                <tr>
                    <th></th>
                    <side-by-side-footer :rows="campaignRows" dir="left" :colspan="colspan"/>
                    <th class="table-center-separator"></th>
                    <side-by-side-footer :rows="campaignRows" dir="right"  :colspan="colspan"/>
                </tr>
            </tfoot>
        </table>

        <btn icon="fas fa-plus" :click="addCampaign">Add Campaign</btn>

        <div style="text-align: center">
            <btn cssClass="btn-primary btn-lg" icon="fas fa-cloud-upload-alt" :click="saveCampaign">Save</btn>
        </div>

        <campaign-create
            :show="show_dialogs.create_campaign"
            :employer_id="employer_id"
            @updated="refresh"
            @close="show_dialogs.create_campaign = false"
        ></campaign-create>

        <billing
            :show="show_dialogs.billing"
            :data_id="show_dialogs.budget_period_id"
            :status="show_dialogs.period_status"
            @close="show_dialogs.billing = false; updated()"
        ></billing>
    </div>
</template>

<script>
import CampaignCreate from "../../../../accounts/Campaign/vue/campaign-create";
import Billing from "../../../BudgetPeriod/vue/dialogs/billing";
import SideBySideHeader from "./side-by-side-header";
import SideBySideFooter from "./side-by-side-footer";
import SideBySideRow from "./side-by-side-row";

export default {
    components: {SideBySideRow, SideBySideFooter, SideBySideHeader, Billing, CampaignCreate},
    props: [
        'employer_id',
        'refreshIndex'
    ],
    data() {

        let columns = [
            'Lead Goals',
            'Lead Setup',
            'MC goal',
            'Direct goal',
            'Budget',
            'JA',
            'FF Order'
        ];

        return {
            columns: columns,
            colspan: columns.length,
            campaignRows: [],
            left: null,
            right: null,
            show_dialogs: {
                create_campaign: false,
                billing: false,
                budget_period_id: null,
                period_status: null,
            },
            loading: true
        };
    },
    watch: {
        refreshIndex() {
            this.refresh();
        }
    },
    methods: {
        refresh() {
            this.loading = true;
            return axios.get(url(`admin/budget/${this.employer_id}/side-by-side`))
                .then(response => {
                    this.campaignRows = response.data.rows;
                    this.left = response.data.left;
                    this.right = response.data.right;
                    this.loading = false;
                });
        },
        saveCampaign() {
            return axios.post(url(`admin/budget/${this.employer_id}/side-by-side`), {
                    'rows': this.campaignRows
                }).then(response => {
                    this.$emit('updated');
                    return this.refresh();
                });
        },
        updated() {
            this.$emit('updated');
            return this.refresh();
        },
        editBilling(budget_period_id, period_status) {
            this.show_dialogs.billing = true;
            this.show_dialogs.budget_period_id = budget_period_id;
            this.show_dialogs.period_status = period_status;
        },
        addCampaign() {
            this.show_dialogs.create_campaign = true;
        }
    },
    created() {
        this.refresh();
    }
}
</script>

<style>
.table-center-separator {
    border-left: solid 2px #eee;
    border-right: solid 2px #eee;
}
</style>
